module.exports = __webpack_public_path__ + "img/icon_1_23.c128b886.png";